import React, { useState } from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
} from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import FAQSchema from '../../FAQSchema';
import AdBanner from '../AdPage/AdBanner';

// Register necessary components
ChartJS.register(
  ArcElement,
  ChartTooltip,
  Legend
);

const HdfcHomeLoanEMiCalculator      = () => {
   const [loanAmount, setLoanAmount] = useState(5000000);
    const [interestRate, setInterestRate] = useState(7.5);
    const [loanTenure, setLoanTenure] = useState(20);
    const [monthlyEMI, setMonthlyEMI] = useState(0);
    const [totalInterest, setTotalInterest] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [amortizationSchedule, setAmortizationSchedule] = useState([]);
    const [activeYear, setActiveYear] = useState(null);
  
    const calculateEMI = () => {
      const principal = loanAmount;
      const annualInterest = interestRate / 100;
      const monthlyInterest = annualInterest / 12;
      const tenureInMonths = loanTenure * 12;
  
      const emi =
        (principal * monthlyInterest * Math.pow(1 + monthlyInterest, tenureInMonths)) /
        (Math.pow(1 + monthlyInterest, tenureInMonths) - 1);
  
      const totalAmount = emi * tenureInMonths;
      const totalInterest = totalAmount - principal;
  
      setMonthlyEMI(emi.toFixed(2));
      setTotalInterest(totalInterest.toFixed(2));
      setTotalAmount(totalAmount.toFixed(2));
  
      const schedule = [];
      let balance = principal;
      // let year = new Date().getFullYear();
      let currentYear = new Date().getFullYear();
  
      let currentMonth = 6;
  
      for (let i = 0; i < tenureInMonths; i++) {
        const interestForMonth = balance * monthlyInterest;
        const principalForMonth = emi - interestForMonth;
        balance -= principalForMonth;
  
        schedule.push({
          // month: i + 1,
          // year: year,
          month: (currentMonth + i) % 12 + 1, // Ensure month is in range 1-12
          year: currentYear + Math.floor((currentMonth + i) / 12),
          principalPaid: principalForMonth,
          interestPaid: interestForMonth,
          totalPayment: emi,
          balance: balance,
        });
  
        // if ((i + 1) % 12 === 0) {
        //   year++;
        // }
      }
  
      setAmortizationSchedule(schedule);
    };
  
    const handleLoanAmountChange = (e) => {
      const value = e.target.value;
      setLoanAmount(value === '' ? 0 : parseInt(value));
    };
  
    const handleInterestRateChange = (e) => {
      const value = e.target.value;
      setInterestRate(value === '' ? 0 : parseFloat(value));
    };
  
    const handleLoanTenureChange = (e) => {
      const value = e.target.value;
      setLoanTenure(value === '' ? 0 : parseInt(value));
    };
  
    const handleYearToggle = (year) => {
      setActiveYear(activeYear === year ? null : year);
    };
  
    const data = {
      labels: ['Principal Amount', 'Total Interest'],
      datasets: [
        {
          label: 'EMI Breakdown',
          data: [loanAmount, totalInterest],
          backgroundColor: ['#36A2EB', '#FF6384'],
        },
      ],
    };
    const categories = [
      { id: 1, name: 'Category 1', link: '/' },
      { id: 2, name: 'Category 2', link: '/' },
      { id: 3, name: 'Category 3', link: '/' },
      { id: 4, name: 'Category 4', link: '/' },
      // Add more categories as needed
    ];
  function Icon({ id, open }) {
      return (
          <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
          >
              <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
          </svg>
      );
    }
    
    
      const [activeIndex, setActiveIndex] = useState(0);
    
       
      const faqs = [
        {
            "question": "What is the minimum EMI for an HDFC home loan?",
            "answer": "The minimum EMI depends on the loan amount and tenure, but for a ₹10 lakh loan over 20 years, it could be around ₹8,500–₹9,000 per month."
          },
          {
            "question": "Can I reduce my EMI in the middle of the tenure?",
            "answer": "Yes, through part-prepayments or increasing tenure, you can reduce your EMI."
          },
          {
            "question": "Is the EMI fixed for the entire tenure?",
            "answer": "Generally yes, if you opt for a fixed-rate loan. For floating rates, EMI can change."
          },
          {
            "question": "Does HDFC charge for prepayment?",
            "answer": "HDFC does not charge for prepayment on floating-rate home loans, but charges may apply on fixed-rate loans."
          },
          {
            "question": "How accurate is TheFinMaster’s EMI calculator?",
            "answer": "It’s highly accurate, based on standard banking formulas and real-time inputs."
          },
          {
            "question": "Is the calculator free to use?",
            "answer": "Yes, TheFinMaster’s EMI calculator is completely free to use, with unlimited access."
          },
          {
            "question": "Can I use it for loan planning before applying?",
            "answer": "Absolutely. It’s meant to help you plan your repayment even before submitting your application."
          },
          {
            "question": "Does the calculator show total interest outgo?",
            "answer": "Yes, it provides a complete breakdown of total interest payable."
          },
          {
            "question": "Can I compare different interest rates?",
            "answer": "Yes, you can easily input various rates to see how your EMI changes."
          },
          {
            "question": "Can I print the amortisation schedule?",
            "answer": "Yes, you can take a screenshot or copy the schedule for reference."
          },
          {
            "question": "How does tenure affect EMI?",
            "answer": "Longer tenure reduces EMI but increases total interest paid."
          },
          {
            "question": "What’s the ideal credit score for low EMI?",
            "answer": "A CIBIL score above 750 is generally preferred for lower interest rates."
          },
          {
            "question": "Can EMI be auto-debited from my bank account?",
            "answer": "Yes, HDFC offers ECS and auto-debit facilities for hassle-free payments."
          },
          {
            "question": "Does HDFC offer EMI holidays?",
            "answer": "In some cases, yes. It depends on the loan agreement and specific requests."
          },
          {
            "question": "Can I refinance my HDFC home loan later?",
            "answer": "Yes, you can switch to a lower rate or another lender subject to terms."
          }
        ]
      const toggleAccordion = (index) => {
        if (activeIndex === index) {
            // If the clicked question is already expanded, collapse it
            setActiveIndex(null);
        } else {
            // If the clicked question is not expanded, expand it
            setActiveIndex(index);
        };
      }
    return (
      <>
  
  <Helmet>
           <title>HDFC Home Loan EMI Calculator – Smart Housing Loan Planner</title>
          <meta  name='description' content='Calculate EMIs for your HDFC home loan with ease. Use this tool to estimate repayments and plan your finances effectively.'/>
          <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/hdfc-home-loan-emi-calculator" />
          <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
          <meta name="robots" content="max-video-preview:-1" />
        </Helmet>
        <FAQSchema faqs={faqs} />
        {/* <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
        <ol className="list-none p-0 inline-flex">
          <li className="flex items-center">
            <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
            <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
            </svg>
          </li>
          <li className="flex items-center">
            <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
            <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
            </svg>
          </li>
            <li className="flex items-center">
            <span className="text-gray-500 ">HDFC Home Loan EMI Calculator</span>
          </li> 
        
        </ol>
      </nav> */}
           <div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
      <div className='py-4 '>
  
     
      <div className="container mx-auto p-4 shadow-xl rounded-md ">
        <h1 className="text-2xl font-bold mb-4"> HDFC Home Loan EMI Calculator</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <div className="mb-4">
              <label className="block text-gray-700 font-semibold">Loan Amount</label>
              <div className="flex items-center">
                <input
                  type="number"
                  min="0"
                  value={loanAmount}
                  onChange={handleLoanAmountChange}
                  className="w-1/2 p-2 border rounded mr-2"
                />
                <span className="text-gray-700">₹ {loanAmount.toLocaleString()}</span>
              </div>
              <input
                type="range"
                min="0"
                max="100000000"
                value={loanAmount}
                onChange={(e) => setLoanAmount(parseInt(e.target.value))}
                className="w-full mt-2"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 font-semibold">Rate of Interest (P.A.)</label>
              <div className="flex items-center">
                <input
                  type="number"
                  min="0"
                  max="100"
                  step="0.1"
                  value={interestRate}
                  onChange={handleInterestRateChange}
                  className="w-1/2 p-2 border rounded mr-2"
                />
                <span className="text-gray-700">{interestRate} %</span>
              </div>
              <input
                type="range"
                min="0"
                max="15"
                step="0.1"
                value={interestRate}
                onChange={(e) => setInterestRate(parseFloat(e.target.value))}
                className="w-full mt-2"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 font-semibold">Loan Tenure (Years)</label>
              <div className="flex items-center">
                <input
                  type="number"
                  min="0"
                  max="30"
                  value={loanTenure}
                  onChange={handleLoanTenureChange}
                  className="w-1/2 p-2 border rounded mr-2"
                />
                <span className="text-gray-700">{loanTenure} Yr</span>
              </div>
              <input
                type="range"
                min="0"
                max="30"
                value={loanTenure}
                onChange={(e) => setLoanTenure(parseInt(e.target.value))}
                className="w-full mt-2"
              />
            </div>
            <button
              onClick={calculateEMI}
              className="bg-blue-500 text-white px-4 py-2 rounded"
            >
              Calculate
            </button>
          </div>
          <div>
            <div className="mb-4">
              <h2 className="text-xl font-bold">Results</h2>
              <p>Monthly EMI: ₹ {parseFloat(monthlyEMI).toLocaleString()}</p>
              <p>Total Principal Amount: ₹ {loanAmount.toLocaleString()}</p>
              <p>Total Interest: ₹ {parseFloat(totalInterest).toLocaleString()}</p>
              <p>Total Amount (Principal + Interest): ₹ {parseFloat(totalAmount).toLocaleString()}</p>
            </div>
            <div>
              <h2 className="text-xl font-bold">Breakdown</h2>
              <div className="flex justify-center">
                <Pie data={data} options={{ maintainAspectRatio: false }} width={300} height={300} />
              </div>
            </div>
          </div>
        </div>
        <div className="mt-6">
          <h2 className="text-xl font-bold mb-4">Amortization Schedule</h2>
          {amortizationSchedule.length > 0 && (
            <div className="flex flex-col space-y-4">
              {Array.from(new Set(amortizationSchedule.map(item => item.year))).map((year, idx) => (
                <div key={idx} className="mb-4 border rounded-md shadow-md">
                  <div
                    className={`cursor-pointer text-lg font-semibold bg-gray-100 p-4 flex justify-between items-center ${activeYear === year ? 'bg-blue-100' : ''}`}
                    onClick={() => handleYearToggle(year)}
                  >
                    <span>{year}</span>
                    <span>{activeYear === year ? '-' : '+'}</span>
                  </div>
                  {activeYear === year && (
                    <div className="overflow-x-auto">
                      <table className="min-w-full bg-white rounded-md shadow-md text-center">
                        <thead>
                          <tr>
                            <th className="py-2 px-4 border-b">Month</th>
                            <th className="py-2 px-4 border-b">Principal Paid</th>
                            <th className="py-2 px-4 border-b">Interest Charged</th>
                            <th className="py-2 px-4 border-b">Total Payment</th>
                            <th className="py-2 px-4 border-b">Balance</th>
                          </tr>
                        </thead>
                        <tbody>
                          {amortizationSchedule.filter(item => item.year === year).map((item, idx) => (
                            <tr key={idx}>
                              <td className="py-2 px-4 border-b">{new Date(0, item.month - 1).toLocaleString('default', { month: 'short' })}</td>
                              <td className="py-2 px-4 border-b">₹ {item.principalPaid.toFixed(2).toLocaleString()}</td>
                              <td className="py-2 px-4 border-b">₹ {item.interestPaid.toFixed(2).toLocaleString()}</td>
                              <td className="py-2 px-4 border-b">₹ {item.totalPayment.toFixed(2).toLocaleString()}</td>
                              <td className="py-2 px-4 border-b">₹ {item.balance.toFixed(2).toLocaleString()}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
     <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6" >
     <div className="w-full md:w-2/3 p-4 mx-auto">
     <div className="container mx-auto py-4">
          <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            Plan Your HDFC Home Loan Payments with TheFinMaster’s EMI Calculator
          </h2>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            Purchasing a home is one of the most significant investments of your life, and planning your finances around it requires precision and insight. With the rising costs of real estate, most individuals opt for home loans to bridge the financial gap. However, repaying a loan over a long tenure demands structured financial planning. That’s where TheFinMaster’s HDFC Home Loan EMI Calculator becomes your ultimate financial assistant. Designed to provide clear, accurate, and instant insights into your monthly repayment obligations, this calculator ensures you’re never caught off guard. With HDFC being one of the leading home loan providers in India, using our EMI calculator specifically for HDFC loans allows you to tailor your finances with unparalleled precision.
          </p>
</div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is a Home Loan EMI?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              A Home Loan EMI (Equated Monthly Instalment) is the fixed amount a borrower pays every month to the lender towards the repayment of their home loan. It comprises both the principal amount and the interest accrued over time. The EMI is determined by several factors including the loan amount, tenure, and interest rate.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              For instance, if you borrow ₹50 lakhs for 20 years at an interest rate of 8.5%, your EMI would be calculated in a way that each month a part of your principal and interest is repaid. Initially, the interest component is higher and gradually decreases, while the principal repayment increases with time. This system ensures that the lender recovers the interest early while maintaining a consistent EMI amount for the borrower.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is HDFC Home Loan EMI Calculator?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The HDFC Home Loan EMI Calculator by TheFinMaster is a specialized digital tool tailored to help you compute monthly instalments on your HDFC home loan. It considers the specifics of HDFC's interest rates, typical loan structures, and borrower profiles to offer a close-to-accurate estimation.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Using this tool, you can:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Input different loan amounts, tenures, and interest rates</li>
              <li>Instantly receive EMI estimates</li>
              <li>View amortisation schedules</li>
              <li>Understand your total repayment and interest outflow</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This calculator simplifies financial forecasting by eliminating the need for complex manual calculations. It’s particularly useful if you’re comparing different loan options or want to explore how prepayments could reduce your financial burden.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Why Use TheFinMaster’s HDFC Home Loan EMI Calculator?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
                <li><strong>Real-time Accuracy:</strong> Unlike manual estimations, the calculator provides precise figures based on real-time formulas.</li>
                <li><strong>Customisation:</strong> Easily change values for loan amount, interest rate, and tenure to find what works best for you.</li>
                <li><strong>Time-Saving:</strong> Get instant results in seconds, helping you make faster decisions.</li>
                <li><strong>Budget Planning:</strong> Know your financial outflows well in advance, so you can budget effectively.</li>
                <li><strong>Interest Comparison:</strong> Evaluate how changes in interest rates impact your total repayment.</li>
                <li><strong>Smart Prepayment Strategy:</strong> Determine how much you can save by prepaying a part of your loan early.</li>
              </ul>
            </p>
          </div>
          <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
         
        </div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Does the HDFC Home Loan EMI Calculator Work?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The EMI calculator works using the standard formula:
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              EMI = [P × R × (1 + R)^N] / [(1 + R)^N – 1]
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Where:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>P is the principal loan amount</li>
              <li>R is the monthly interest rate (annual interest rate divided by 12 × 100)</li>
              <li>N is the loan tenure in months</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Example:</strong><br />
              Let’s assume:<br />
              Loan Amount = ₹60 lakhs<br />
              Interest Rate = 8.25% per annum<br />
              Tenure = 20 years<br />
              Monthly Interest Rate = 8.25 / 12 / 100 = 0.006875<br />
              Tenure in Months = 20 × 12 = 240 months<br />
              Now applying the formula: EMI = [6000000 × 0.006875 × (1 + 0.006875)^240] / [(1 + 0.006875)^240 – 1]<br />
              EMI ≈ ₹51,104<br />
              This means you’ll need to pay approximately ₹51,104 every month for the next 20 years.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is the Amortisation Schedule?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              An amortisation schedule is a detailed table showing how your EMI is distributed over the entire loan tenure. It outlines how much of each EMI goes towards interest and principal repayment and helps you understand your repayment structure over time.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>12-Month Amortisation Schedule (Example):</strong>
            </p>
            {/* <div className="overflow-x-auto">
              <table className="w-full text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-4 border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-4 py-2 text-left">Month</th>
                    <th className="border px-4 py-2 text-left">EMI (₹)</th>
                    <th className="border px-4 py-2 text-left">Principal (₹)</th>
                    <th className="border px-4 py-2 text-left">Interest (₹)</th>
                    <th className="border px-4 py-2 text-left">Outstanding (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border px-4 py-2">1</td>
                    <td className="border px-4 py-2">51,104</td>
                    <td className="border px-4 py-2">11,104</td>
                    <td className="border px-4 py-2">40,000</td>
                    <td className="border px-4 py-2">5,988,896</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">2</td>
                    <td className="border px-4 py-2">51,104</td>
                    <td className="border px-4 py-2">11,154</td>
                    <td className="border px-4 py-2">39,950</td>
                    <td className="border px-4 py-2">5,977,742</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">3</td>
                    <td className="border px-4 py-2">51,104</td>
                    <td className="border px-4 py-2">11,205</td>
                    <td className="border px-4 py-2">39,899</td>
                    <td className="border px-4 py-2">5,966,537</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">4</td>
                    <td className="border px-4 py-2">51,104</td>
                    <td className="border px-4 py-2">11,256</td>
                    <td className="border px-4 py-2">39,848</td>
                    <td className="border px-4 py-2">5,955,281</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">5</td>
                    <td className="border px-4 py-2">51,104</td>
                    <td className="border px-4 py-2">11,307</td>
                    <td className="border px-4 py-2">39,797</td>
                    <td className="border px-4 py-2">5,943,974</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">6</td>
                    <td className="border px-4 py-2">51,104</td>
                    <td className="border px-4 py-2">11,358</td>
                    <td className="border px-4 py-2">39,746</td>
                    <td className="border px-4 py-2">5,932,616</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">7</td>
                    <td className="border px-4 py-2">51,104</td>
                    <td className="border px-4 py-2">11,410</td>
                    <td className="border px-4 py-2">39,694</td>
                    <td className="border px-4 py-2">5,921,206</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">8</td>
                    <td className="border px-4 py-2">51,104</td>
                    <td className="border px-4 py-2">11,461</td>
                    <td className="border px-4 py-2">39,643</td>
                    <td className="border px-4 py-2">5,909,745</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">9</td>
                    <td className="border px-4 py-2">51,104</td>
                    <td className="border px-4 py-2">11,513</td>
                    <td className="border px-4 py-2">39,591</td>
                    <td className="border px-4 py-2">5,898,232</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">10</td>
                    <td className="border px-4 py-2">51,104</td>
                    <td className="border px-4 py-2">11,565</td>
                    <td className="border px-4 py-2">39,539</td>
                    <td className="border px-4 py-2">5,886,667</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">11</td>
                    <td className="border px-4 py-2">51,104</td>
                    <td className="border px-4 py-2">11,617</td>
                    <td className="border px-4 py-2">39,487</td>
                    <td className="border px-4 py-2">5,875,050</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">12</td>
                    <td className="border px-4 py-2">51,104</td>
                    <td className="border px-4 py-2">11,670</td>
                    <td className="border px-4 py-2">39,434</td>
                    <td className="border px-4 py-2">5,863,380</td>
                  </tr>
                </tbody>
              </table>
            </div> */}
            <div className="mt-6">
  {/* Table view for medium and up */}
  <div className="hidden md:block overflow-x-auto">
    <table className="w-full text-lg text-gray-600 mt-4 border-collapse">
      <thead>
        <tr className="bg-gray-100">
          <th className="border px-4 py-2 text-left">Month</th>
          <th className="border px-4 py-2 text-left">EMI  (₹)</th>
          <th className="border px-4 py-2 text-left">Principal    (₹)</th>
          <th className="border px-4 py-2 text-left">Interest (₹)</th>
          <th className="border px-4 py-2 text-left">Outstanding  (₹)</th>
        </tr>
      </thead>
      <tbody>
        {[
          
          ["1", "51,104", "11,104", "40,000", "5,988,896"],
  ["2", "51,104", "11,154", "39,950", "5,977,742"],
  ["3", "51,104", "11,205", "39,899", "5,966,537"],
  ["4", "51,104", "11,256", "39,848", "5,955,281"],
  ["5", "51,104", "11,307", "39,797", "5,943,974"],
  ["6", "51,104", "11,358", "39,746", "5,932,616"],
  ["7", "51,104", "11,410", "39,694", "5,921,206"],
  ["8", "51,104", "11,461", "39,643", "5,909,745"],
  ["9", "51,104", "11,513", "39,591", "5,898,232"],
  ["10", "51,104", "11,565", "39,539", "5,886,667"],
  ["11", "51,104", "11,617", "39,487", "5,875,050"],
  ["12", "51,104", "11,670", "39,434", "5,863,380"]
     
        ].map(([month, emi, interest, principal, balance], index) => (
          <tr key={index}>
            <td className="border px-4 py-2">{month}</td>
            <td className="border px-4 py-2">{emi}</td>
            <td className="border px-4 py-2">{interest}</td>
            <td className="border px-4 py-2">{principal}</td>
            <td className="border px-4 py-2">{balance}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Card layout for small screens */}
  <div className="md:hidden space-y-4 mt-4">
    {[
            ["1", "51,104", "11,104", "40,000", "5,988,896"],
            ["2", "51,104", "11,154", "39,950", "5,977,742"],
            ["3", "51,104", "11,205", "39,899", "5,966,537"],
            ["4", "51,104", "11,256", "39,848", "5,955,281"],
            ["5", "51,104", "11,307", "39,797", "5,943,974"],
            ["6", "51,104", "11,358", "39,746", "5,932,616"],
            ["7", "51,104", "11,410", "39,694", "5,921,206"],
            ["8", "51,104", "11,461", "39,643", "5,909,745"],
            ["9", "51,104", "11,513", "39,591", "5,898,232"],
            ["10", "51,104", "11,565", "39,539", "5,886,667"],
            ["11", "51,104", "11,617", "39,487", "5,875,050"],
            ["12", "51,104", "11,670", "39,434", "5,863,380"]
    ].map(([month, emi, interest, principal, balance], index) => (
      <div key={index} className="bg-white shadow rounded-xl p-4 text-sm text-gray-700 space-y-1 border">
        <div><span className="font-semibold">Month:</span> {month}</div>
        <div><span className="font-semibold">EMI (₹):</span> {emi}</div>
        <div><span className="font-semibold"> Principal   (₹):</span> {interest}</div>
        <div><span className="font-semibold">Interest   (₹):</span> {principal}</div>
        <div><span className="font-semibold"> Outstanding  (₹):</span> {balance}</div>
      </div>
    ))}
  </div>
</div>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Over time, the interest portion of your EMI reduces while the principal component increases.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Factors Affecting Your Home Loan EMI
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <ol className="list-decimal pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
                <li><strong>Loan Amount:</strong> The total loan you borrow has a direct impact on your EMI. A higher principal loan amount will result in a proportionately larger EMI, especially if the interest rate and tenure remain unchanged.</li>
                <li><strong>Interest Rate:</strong> Even a slight variation in the interest rate—say 0.5%—can lead to a noticeable difference in your monthly EMI and total loan repayment. Choosing between fixed and floating rates also affects long-term EMI stability.</li>
                <li><strong>Loan Tenure:</strong> A longer repayment tenure reduces your monthly EMI burden, making it more affordable month-to-month. However, it increases the total interest outgo over the life of the loan, making the loan more expensive in the long run.</li>
                <li><strong>Processing Fees:</strong> Though it doesn’t directly influence your EMI amount, processing fees add to your upfront cost. It can slightly impact your initial budget and should be considered when calculating total cost of borrowing.</li>
                <li><strong>Prepayments:</strong> Making part-prepayments during the loan tenure helps in reducing the principal amount. This leads to a decrease in the remaining interest payable and future EMIs, or a shorter loan tenure, depending on lender terms.</li>
                <li><strong>Credit Score:</strong> A high credit/CIBIL score (usually 750+) shows financial discipline and increases your chances of securing a lower interest rate. A lower rate means reduced EMIs and overall loan cost.</li>
                <li><strong>Income & Profile:</strong> Lenders evaluate your income stability, job profile, and existing liabilities. A steady and high income with fewer liabilities can fetch you better interest rates and favorable terms, indirectly reducing your EMI burden.</li>
              </ol>
            </p>
          </div>
        </div>

     <div className="w-full md:w-1/3 p-4">
       <div className="bg-white shadow-md rounded-lg overflow-hidden">
         <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
           <h2 className="text-lg font-semibold ">Popular Categories</h2>
         </div>
         <div className="p-2 ">
         <ul>
                                <Link to='/financial-tools-calculators/swp-calculator'>
                                    <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/fd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/rd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/nps-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                    
                                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                </Link>
                                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>

                          {/* Ad Banner */}
  <div className="mt-4">
    <div className="bg-white shadow-md rounded-lg overflow-hidden">
      <div className="p-3 w-full h-auto rounded-md object-cover">
        <AdBanner displayOrder="2" />
      </div>
    </div>
  </div>
                    <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                            <h2 className="text-lg font-semibold">More Categories</h2>
                        </div>
                        <div className="p-2">
                        <ul>
                                <Link to='/financial-tools-calculators/gratuity-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/APY-calculator'>
                                    <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/cagr-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/gst-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                </Link>
                                {/* <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                </Link> */}
                                <Link to='/financial-tools-calculators/inflation-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/salary-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/brokerage-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/tds-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                </Link>
             {/* {moreCategories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
           </ul>
         </div>
       </div>

     </div>

   </div>
   </div>
   <div className="max-w-4xl mx-auto lg:px-6 md:px-6 px-2 py-6">
                <h2 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h2>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
   </>
  );
};

export default HdfcHomeLoanEMiCalculator  ;
